import { createActions, createReducer } from 'reduxsauce'

import SetorService from '../servicos/SetorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaSetorInicio: [],
    buscaSetorSucesso: ['setor'],
    buscaSetorErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaSetors = () => {
    return dispatch => {
        dispatch(Creators.buscaSetorInicio())
        let serv = new SetorService()
        return serv
            .getSetor()
            .then(response => dispatch(Creators.buscaSetorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaSetorErro(error)))
    }
}

const buscaSetorInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaSetorErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaSetorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.setor, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_SETOR_INICIO]: buscaSetorInicio,
    [Types.BUSCA_SETOR_ERRO]: buscaSetorErro,
    [Types.BUSCA_SETOR_SUCESSO]: buscaSetorSucesso,
})
